const BRL_MONEY_INPUT_MAX_LENGTH = 24;
const BRL_MONEY_OPERATION_VALUE_MAX = 1_000_000_000;
const BRL_MONEY_PUBLIC_DECIMAL_PLACES = 8;
const BRL_MONEY_PU_DECIMAL_PLACES = 8;
const BRL_MONEY_FINANCIAL_DECIMAL_PLACES = 2;
const BRL_MONEY_FINANCIAL_INTEGER_DIGITS = 13; // alinhado a decimal(21,8) → 21-8
const BRL_MONEY_TAXA_DECIMAL_PLACES = 4;
const BRL_MONEY_SEMANTIC_SELECTOR =
  '.input--brl-money-pu, .input--brl-money-financial, .input--brl-money-taxa';
const BRL_MONEY_TYPED_SELECTOR =
  '.input--brl-money-private, .input--brl-money-currency-term, .input--brl-money-public, ' +
  '.input--brl-money-pu, .input--brl-money-financial, .input--brl-money-taxa';

const Masks = {
  decimalPlacesMoney: 2,
  decimalPlacesPercent: 1,
  brlMoneyInputMaxLength: BRL_MONEY_INPUT_MAX_LENGTH,
  // novas mascaras com padronização de casas decimais
  brlMoneyPuDecimalPlaces: BRL_MONEY_PU_DECIMAL_PLACES,
  brlMoneyFinancialDecimalPlaces: BRL_MONEY_FINANCIAL_DECIMAL_PLACES,
  brlMoneyFinancialIntegerDigits: BRL_MONEY_FINANCIAL_INTEGER_DIGITS,
  brlMoneyTaxaDecimalPlaces: BRL_MONEY_TAXA_DECIMAL_PLACES,
  parseBrazilianMoney(str) {
    if (!str) return NaN;

    const cleaned = str.toString().trim().replace(/[^\d,.-]/g, '');
    if (!cleaned) return NaN;

    if (cleaned.includes(',')) {
      return parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
    }

    if (cleaned.includes('.') && cleaned.split('.').pop().length === 3) {
      return parseFloat(cleaned.replace(/\./g, ''));
    }

    return parseFloat(cleaned);
  },

  // Arredondamento half-up (15.757 → 15.76)
  roundHalfUp(num, decimalPlaces) {
    const places = Number(decimalPlaces);
    if (!Number.isFinite(num) || !Number.isFinite(places) || places < 0) return num;

    const factor = 10 ** places;
    return Math.round(Number(num) * factor) / factor;
  },

  formatBrazilianMoney(num, decimalPlaces) {
    const maxDecimals = decimalPlaces;
    const minDecimals = Math.min(2, maxDecimals);
    const rounded = Masks.roundHalfUp(num, maxDecimals);
    const fixed = Number(rounded).toFixed(maxDecimals);
    const parts = fixed.split('.');
    let decimals = parts[1] || '';

    while (decimals.length > minDecimals && decimals.endsWith('0')) {
      decimals = decimals.slice(0, -1);
    }

    const integer = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

    return decimals.length ? `${integer},${decimals}` : integer;
  },

  fixMoneyInputValues($, selector, decimalPlaces) {
    $(selector).each((n, el) => {
      const value = el.value;
      if (!value) return;

      const parsed = Masks.parseBrazilianMoney(value);
      if (Number.isNaN(parsed)) return;

      $(el).val(Masks.formatBrazilianMoney(parsed, decimalPlaces));
    });
  },

  fixDateInputValues($) {
    $('.input--date, .datepicker').each((n, el) => {
      const date = el.value;
      if (!date || !/^\d{4}-\d{2}-\d{2}/.test(date)) return;

      const [year, month, day] = date.split('-');
      $(el).val(`${day}/${month}/${year}`);
    });
  },
  brlMoneyDecimalPlaces($el) {
    const fromData = parseInt($el.data('brlDecimals'), 10);
    if (!Number.isNaN(fromData) && fromData > 0) return fromData;
    if ($el.hasClass('input--brl-money-pu')) return BRL_MONEY_PU_DECIMAL_PLACES;
    if ($el.hasClass('input--brl-money-financial')) return BRL_MONEY_FINANCIAL_DECIMAL_PLACES;
    if ($el.hasClass('input--brl-money-taxa')) return BRL_MONEY_TAXA_DECIMAL_PLACES;
    if ($el.hasClass('input--brl-money-private')) return 8;
    if ($el.hasClass('input--brl-money-public')) return BRL_MONEY_PUBLIC_DECIMAL_PLACES;
    return Masks.decimalPlacesMoney;
  },
  applyMaskOnMoneyInputs($) {
    $('.input--brl-money').each((n, el) => {
      const $el = $(el);
      const value = el.value.trim();
      if (!value) return;

      const decimalPlaces = Masks.brlMoneyDecimalPlaces($el);
      const isSemantic = $el.is(BRL_MONEY_SEMANTIC_SELECTOR);

      // Classes novas: arredonda na carga. Legado: mantém truncate nas casas.
      if (isSemantic) {
        const parsed = Masks.parseBrazilianMoney(value);
        if (!Number.isNaN(parsed)) {
          $el.val(Masks.formatBrazilianMoney(parsed, decimalPlaces));
        }
        return;
      }

      if (value.includes(',')) {
        const [integerPart, decimalPart] = value.split(',');
        const integer = integerPart.replace(/\./g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        const limitedDecimal = (decimalPart || '').substring(0, decimalPlaces);
        $el.val(limitedDecimal.length ? `${integer},${limitedDecimal}` : integer);
        return;
      }

      const parsed = Masks.parseBrazilianMoney(value);
      if (!Number.isNaN(parsed)) {
        $el.val(Masks.formatBrazilianMoney(parsed, decimalPlaces));
      }
    });
  },
  phoneMask: val => (val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009'),
  barcodeMask: (val) => {
    const formattedVal = val.replace(/\D/g, '');

    if (formattedVal[0] === '8') {
      return '00000000000-0 00000000000-0 00000000000-0 00000000000-0';
    }
    return '00000.00000 00000.000000 00000.000000 0 00000000000000';
  },
  documentNumberMask: (val) => {
    const raw = val || '';
    const alnum = raw.replace(/[^a-zA-Z0-9]/g, '');
    const digits = raw.replace(/\D/g, '');
    const hasLetter = /[a-zA-Z]/.test(alnum);
    if (hasLetter || digits.length > 11) {
      return 'XX.XXX.XXX/XXXX-XX';
    }
    // Mesmo formato visual de CPF, mas com X (alfanumérico) para aceitar letra ao digitar.
    return 'XXX.XXX.XXX-XX';
  },
  // Sempre molde alfanumérico: aceita letras desde o primeiro caractere (CNPJ alfanumérico).
  cnpjMask: () => 'XX.XXX.XXX/XXXX-XX',
  onKeyPress: f => ({ onKeyPress: (val, e, field, options) => field.mask(f(val), options) }),

  applyAll($) {
    const m = Masks;
    if ($ && $.jMaskGlobals && $.jMaskGlobals.translation) {
      $.jMaskGlobals.translation.X = { pattern: /[a-zA-Z0-9]/ };
    }
    m.fixMoneyInputValues($, '.input--money:not(.input--brl-money-private)', m.decimalPlacesMoney);
    m.fixMoneyInputValues($, '.input--percent', m.decimalPlacesPercent);
    m.fixDateInputValues($);
    m.applyMaskOnMoneyInputs($);

    $('.input--number').val(parseFloat($('.input--number').val()).toFixed(0))
    const alnumTranslation = { translation: { X: { pattern: /[a-zA-Z0-9]/ } } };
    const docMaskDynamic = m.onKeyPress(m.documentNumberMask);
    const documentNumberOpts = Object.assign({}, alnumTranslation, {
      onKeyPress(val, e, field, options) {
        docMaskDynamic.onKeyPress(val, e, field, options);
        stripDocumentNumberMaxlength($(field));
      },
    });
    $('input.document_number').mask(m.documentNumberMask, documentNumberOpts);
    stripDocumentNumberMaxlength($('input.document_number'));
    bindDocumentNumberCpfCnpjBridge($, documentNumberOpts);
    bindDocumentNumberPaste($, documentNumberOpts);
    $('.phone').mask(m.phoneMask, m.onKeyPress(m.phoneMask));

    $('.input--barcode').bind('paste', function (e) {
      e.preventDefault();

      let pastedText;

      const originalEvent = e.originalEvent;

      if (originalEvent.clipboardData && originalEvent.clipboardData.getData) {
        pastedText = originalEvent.clipboardData.getData('text/plain');
      } else if (window.clipboardData && window.clipboardData.getData) {
        pastedText = window.clipboardData.getData('Text');
      }

      const newValue = pastedText.replace(/\D/g, '');

      $(this).unmask();
      $(this).val(newValue);
      $(this).mask(m.barcodeMask, m.onKeyPress(m.barcodeMask));
      $(this).val($(this).masked(newValue));
    });

    $('.input--brl-money').val
    $('.input--new-percent').val
    $('.input--new-percent-2').val

    $('.input--time').mask('00:00');
    $('.input--barcode').mask(m.barcodeMask, m.onKeyPress(m.barcodeMask));
    $('.input--cpf').mask('000.000.000-00', { reverse: true });
    $('.input--cnpj').mask(
      m.cnpjMask,
      Object.assign({}, alnumTranslation, m.onKeyPress(m.cnpjMask), { reverse: true })
    );
    $(document).off('blur.cnpjDocUpper', '.input--cnpj, input.document_number');
    $(document).on('blur.cnpjDocUpper', '.input--cnpj, input.document_number', function () {
      const $field = $(this);
      const v = $field.val();
      if (v && /[a-z]/.test(v)) {
        $field.val(v.toUpperCase());
      }
    });
    $('.input--money:not(.input--brl-money-private)').mask('##0,00', { reverse: true, placeholder: 'R$ 0.00' });
    $('.input--percent').mask('##0.0', { reverse: true, placeholder: 'Ex: 11,1' });
    $('.input--long-percent').mask('##0.00', { reverse: true, placeholder: 'Ex: 11,12' });
    $('.input--very-long-percent').mask('##0.0000', { reverse: true, placeholder: 'Ex: 11,1234' });
    $('.input--extra-long-percent').mask('##0.000000', { reverse: true, placeholder: 'Ex: 11,123456' });
    $('.input--maximum-percent').mask('##0,00000000', { reverse: true, placeholder: 'Ex: 11,12345678' });
    $('.input--cep').mask('00000-000');
    $('.input--bank-account').mask('##0-0', { reverse: true, placeholder: 'Ex: 1234-5' });
    $('.input--bank-agency').mask('##0', { reverse: true, placeholder: 'Ex: 1234' });

    $('.input--new-percent-mask').keyup(function (event) {
      let value = removeSpecialCharactersAndLetters(event.target.value);
      let hasDecimal = value.substring(0, value.length - 1).includes(',');
      if (hasDecimal && event.key == ',') {
        event.target.value = value.substring(0, value.length - 1);
        return;
      } else if (value == ",") {
        event.target.value = "";
        return;
      }
      let integer = hasDecimal ? value.split(',')[0] : value;
      let decimal = hasDecimal ? value.split(',')[1] : null;
      let newValue = `${integer}`
      let hasNewDecimal = event.target.dataset.decimalplaces;
      const decimalPlaces = hasNewDecimal ? parseInt(hasNewDecimal) : 2;
      if (decimal) {
        newValue += limitDecimal(decimal, decimalPlaces)
      }
      event.target.value = newValue;
    });

    $('.input--8-percent-mask').keyup(function (event) {
      let value = removeSpecialCharactersAndLetters(event.target.value);
      let hasDecimal = value.substring(0, value.length - 1).includes(',');
      if (hasDecimal && event.key == ',') {
        event.target.value = value.substring(0, value.length - 1);
        return;
      } else if (value == ",") {
        event.target.value = "";
        return;
      }
      let integer = hasDecimal ? value.split(',')[0] : value;
      let decimal = hasDecimal ? value.split(',')[1] : null;
      let newValue = `${integer}`
      if (decimal) {
        newValue += limitDecimal(decimal, 8)
      }
      event.target.value = newValue;
    });

    $(BRL_MONEY_TYPED_SELECTOR).each(function () { 
      const $input = $(this);
      const maxLength = $input.data('brlMaxLength') || BRL_MONEY_INPUT_MAX_LENGTH;

      // Simple Form em decimal(15,2) gera type=number e max=999999 (6 dígitos)
      $input.attr('type', 'text');
      $input.removeAttr('min').removeAttr('max').removeAttr('step');
      $input.attr('maxlength', maxLength);
      $input.attr('inputmode', 'decimal');
      $input.attr('autocomplete', 'off');
    });

    $('.input--brl-money-private').on('keyup input', function (event) {
      const decimalPlaces = parseInt($(this).data('brlDecimals'), 10) || 8;
      formatBrlMoneyInput(event, decimalPlaces);
    });
    $('.input--brl-money-operation-max.input--brl-money-private').each(function clampOperationValue() {
      const $input = $(this);
      const decimalPlaces = parseInt($input.data('brlDecimals'), 10) || 8;
      clampBrlMoneyInput($input, decimalPlaces);
    });
    $('.input--brl-money-currency-term').keyup(function (event) {
      formatBrlMoneyInput(event, 20);
    });
    $('.input--brl-money-public').on('keyup input', function (event) {
      formatBrlMoneyInput(event, Masks.brlMoneyDecimalPlaces($(this)));
    });

    // Máscaras semânticas novas (não alteram o legado private/public)
    $('.input--brl-money-pu').on('keyup input', function (event) {
      formatBrlMoneyInput(event, Masks.brlMoneyDecimalPlaces($(this)));
    });
    $('.input--brl-money-financial').on('keyup input', function (event) {
      // Limite de 13 dígitos inteiros só na digitação (não corta resultado de cálculo no blur)
      formatBrlMoneyInput(event, Masks.brlMoneyDecimalPlaces($(this)), BRL_MONEY_FINANCIAL_INTEGER_DIGITS);
    });
    $('.input--brl-money-taxa').on('keyup input', function (event) {
      formatBrlMoneyInput(event, Masks.brlMoneyDecimalPlaces($(this)));
    });
    $(BRL_MONEY_SEMANTIC_SELECTOR).on('blur', function () {
      roundBrlMoneyInput($(this));
    });
    $('.input--brl-money-operation-max').filter(BRL_MONEY_SEMANTIC_SELECTOR).each(function clampSemanticOperationValue() {
      const $input = $(this);
      clampBrlMoneyInput($input, Masks.brlMoneyDecimalPlaces($input));
    });

    $('.input--number').keyup(function (event) {
      let value = removeSpecialCharactersAndLetters(event.target.value);
      event.target.value = parseFloat(value).toFixed(0);
    })

    const invalidChars = ["-", "e", "+", "E"];

    $(".operators-forbidden").keydown( function (e) {
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    });

    function formatNumber(str) {
      return str.toString().replace(/\./g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    }

    function removeSpecialCharactersAndLetters(str) {
      return str.toString().replace(/[^0-9,]/g, '');
    }

    function limitDecimal(str, limit) {
      const decimals = str || '';
      const trimmed = decimals.length > limit ? decimals.substring(0, limit) : decimals;
      return `,${trimmed}`;
    }

    function brlMoneyMaxAmount($input) {
      const fromData = parseFloat($input.data('brlMax'));
      if (!Number.isNaN(fromData) && fromData > 0) return fromData;
      if ($input.hasClass('input--brl-money-operation-max')) return BRL_MONEY_OPERATION_VALUE_MAX;
      return null;
    }

    function clampBrlMoneyInput($input, decimalPlaces) {
      const maxAmount = brlMoneyMaxAmount($input);
      if (!maxAmount) return;

      const parsed = Masks.parseBrazilianMoney($input.val());
      if (Number.isNaN(parsed) || parsed <= maxAmount) return;

      $input.val(Masks.formatBrazilianMoney(maxAmount, decimalPlaces));
    }

    function roundBrlMoneyInput($input) {
      const value = ($input.val() || '').toString().trim();
      if (!value) return;

      const parsed = Masks.parseBrazilianMoney(value);
      if (Number.isNaN(parsed)) return;

      const decimalPlaces = Masks.brlMoneyDecimalPlaces($input);
      $input.val(Masks.formatBrazilianMoney(parsed, decimalPlaces));
      clampBrlMoneyInput($input, decimalPlaces);
    }

    function formatBrlMoneyInput(event, decimalPlaces, maxIntegerDigits = null) {
      const $input = $(event.target);
      let value = removeSpecialCharactersAndLetters(event.target.value);

      if (value === ',') {
        event.target.value = '';
        return;
      }

      // Só bloqueia vírgula duplicada (não a primeira)
      if (event.type === 'keyup' && event.key === ',' && (value.match(/,/g) || []).length > 1) {
        event.target.value = value.substring(0, value.length - 1);
        return;
      }

      const commaIndex = value.indexOf(',');
      const hasDecimal = commaIndex !== -1;
      let integer = hasDecimal ? value.substring(0, commaIndex) : value;
      const decimal = hasDecimal ? value.substring(commaIndex + 1) : null;

      // Limite de dígitos antes da vírgula (ex.: financial = 13), sem contar pontos de milhar
      if (maxIntegerDigits && maxIntegerDigits > 0) {
        const integerDigits = integer.replace(/\D/g, '');
        if (integerDigits.length > maxIntegerDigits) {
          integer = integerDigits.substring(0, maxIntegerDigits);
        }
      }

      let newValue = formatNumber(integer);

      if (hasDecimal) {
        newValue += limitDecimal(decimal, decimalPlaces);
      }

      event.target.value = newValue;
      clampBrlMoneyInput($input, decimalPlaces);
    }
  },
};

function stripDocumentNumberMaxlength($nodes) {
  $nodes.each(function stripOne() {
    const $n = $(this);
    if ($n.data('mask-maxlength')) {
      $n.removeAttr('maxlength').removeData('mask-maxlength');
    } else {
      $n.removeAttr('maxlength');
    }
  });
}

function applyDocumentNumberPastedValue($field, clipboardText, documentNumberOpts) {
  let text = clipboardText == null ? '' : String(clipboardText).trim();
  try {
    text = text.normalize('NFKC');
  } catch (_e) {
    void _e;
  }
  text = text.replace(/[\u00A0\u2007\u202F]/g, '');
  const alnum = text.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  const hasLetter = /[A-Z]/.test(alnum);
  let normalized = '';
  if (hasLetter) {
    normalized = alnum.replace(/[^0-9A-Z]/g, '').substring(0, 14);
  } else {
    normalized = text.replace(/\D/g, '').substring(0, 14);
  }
  if (!normalized) return;

  $field.unmask();
  $field.val(normalized);
  $field.mask(Masks.documentNumberMask, documentNumberOpts);
  stripDocumentNumberMaxlength($field);

  const input = $field.get(0);
  const placeEnd = () => {
    if (!input || document.activeElement !== input) return;
    const len = ($field.val() || '').length;
    try {
      input.setSelectionRange(len, len);
    } catch (_err) {
      void _err;
    }
  };
  setTimeout(placeEnd, 0);
  setTimeout(placeEnd, 25);
}

function bindDocumentNumberPaste($, documentNumberOpts) {
  $(document).off('paste.documentNumberCustom', 'input.document_number');
  $(document).on('paste.documentNumberCustom', 'input.document_number', function (e) {
    const $field = $(this);
    const ev = e.originalEvent || e;
    let text = '';
    if (ev.clipboardData && ev.clipboardData.getData) {
      text = ev.clipboardData.getData('text/plain') || '';
    } else if (window.clipboardData && window.clipboardData.getData) {
      text = window.clipboardData.getData('Text') || '';
    }
    const digitCount = text.replace(/\D/g, '').length;
    const hasLetter = /[a-zA-Z]/.test(text.replace(/[^a-zA-Z0-9]/g, ''));

    if (!hasLetter && digitCount < 11) {
      const fix = () => stripDocumentNumberMaxlength($field);
      setTimeout(fix, 0);
      setTimeout(fix, 120);
      return;
    }

    e.preventDefault();
    applyDocumentNumberPastedValue($field, text, documentNumberOpts);
  });
}

function bindDocumentNumberCpfCnpjBridge($, documentNumberOpts) {
  $(document).off('keydown.documentNumberCpfCnpj', 'input.document_number');
  $(document).on('keydown.documentNumberCpfCnpj', 'input.document_number', function (e) {
    const key = e.key;
    if (!key || key.length !== 1 || !/[0-9]/.test(key)) return;
    if (e.ctrlKey || e.metaKey || e.altKey) return;

    const $field = $(this);
    const raw = $field.val() || '';
    const alnum = raw.replace(/[^a-zA-Z0-9]/g, '');
    if (/[a-zA-Z]/.test(alnum)) return;

    const digits = raw.replace(/\D/g, '');
    if (digits.length !== 11) return;

    e.preventDefault();

    const merged = digits + key;
    $field.unmask();
    $field.val(merged);
    $field.mask(Masks.documentNumberMask, documentNumberOpts);
    stripDocumentNumberMaxlength($field);

    const input = $field.get(0);
    const placeCaretAtEnd = () => {
      if (!input || document.activeElement !== input) return;
      const len = ($field.val() || '').length;
      try {
        input.setSelectionRange(len, len);
      } catch (_err) {
        void _err;
      }
    };
    const delay = $ && $.jMaskGlobals && $.jMaskGlobals.keyStrokeCompensation
      ? $.jMaskGlobals.keyStrokeCompensation + 15
      : 25;
    setTimeout(placeCaretAtEnd, 0);
    setTimeout(placeCaretAtEnd, delay);
  });
}

onLoad(Masks.applyAll);

if (typeof window !== 'undefined') {
  window.Masks = Masks;
}
